// @flow

//
// React
//
import React from 'react';

//
// Type
//
import {
    type CellRendererFactoryProps,
    type CellProps,
} from '../types/CellProps';

//
// Formatter
//
import { fmtNumber } from '../../../../trix-web-data-commons';

//
// Helper
//
import { renderAsLink } from './tools';

//
// Component
//
const createNumberCellRenderer = (cfg: {
    onClick: (data: any) => void,

    fmt: any,
}): any => (props: CellProps): any => {
    const fmt = (cfg.fmt) ? cfg.fmt : '0';
    return (
        <div>
            {renderAsLink(cfg.onClick, props.row)(fmtNumber(props.value, fmt))}
        </div>
    );
};
export default createNumberCellRenderer;
